/**
 * Created by wjjn3481 on 2017/6/26.
 */

const cookies = {
    set (key, value, days = 7) {
        let expires
        if (days) {
            let date = new Date()
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
            expires = '; expires=' + date.toGMTString()
        } else {
            expires = ''
        }
        document.cookie = key + '=' + JSON.stringify(value) + expires + '; path=/'
    },

    get (key) {
        if (document.cookie.length > 0) {
            let start = document.cookie.indexOf(key + '=')
            if (start !== -1) {
                start = start + key.length + 1
                let end = document.cookie.indexOf(';', start)
                if (end === -1) {
                    end = document.cookie.length
                }
                return JSON.parse(document.cookie.substring(start, end))
            }
        }
        return null
    },

    remove (key) {
        this.set(key, '', -1)
    }
}
const storage = {
    set (key, value, days = 7) {
        localStorage.setItem(key, JSON.stringify(value))
    },

    get (key) {
        let value = localStorage.getItem(key)
        return value ? JSON.parse(value) : null
    },

    remove (key) {
        localStorage.removeItem(key)
    }
}

// 检查是否支持localStorage
function supportStorage () {
    let test = 'supportStorageTest'
    try {
        localStorage.setItem(test, test)
        localStorage.removeItem(test)
        return true
    } catch (e) {
        return false
    }
}

const myStore = (function () {
    return supportStorage() ? storage : cookies
})()

export default myStore


// WEBPACK FOOTER //
// ./src/views/login/myStore.js